// Link day-work indicator w_{u,day} to assignments x_{u,e,r} on that day:
// For each assignment x on day d and user u: x <= w_{u,d}
// Requires: decisionVariables, eventDateYmd, dayWorkDecisionVariables
export function buildMediaDayWorkIndicatorConstraints(model, _params = {}) {
  const idx = model?.optimizationIndexes || {};
  const decisionVars = idx.decisionVariables || {};
  const eventDateYmd = idx.eventDateYmd || {};
  const declaredW = new Set(Object.keys(idx.dayWorkDecisionVariables || {}));

  const constraints = [];
  for (const [name, meta] of Object.entries(decisionVars)) {
    const uKey = meta?.userKey;
    const eKey = meta?.eventKey;
    if (!uKey || !eKey) continue;
    const day = eventDateYmd[eKey];
    if (!day) continue;
    const wName = `w_${uKey}_${day}`;
    if (!declaredW.has(wName)) continue;
    // x - w <= 0
    constraints.push({ linear: { vars: [name, wName], coeffs: [1, -1] }, domain: [-100000, 0] });
  }
  return constraints;
}

